import React from 'react';
import { FDBodyText, FDBox, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import Resource from 'facet-rest/src/domain/Resource';
import {
  ServiceItem,
} from 'Views/Page/Content/Templates/WizardTemplates/OnboardingInvestmentProfileInvestingToolboxTemplate/Layout/ServiceItem';

const ServiceGroup = ({ group }) => {
  const serviceLineItems = group.attr('services')?.resources().list() || [];
  return (
    <FDStack direction={'column'} spacing={1}>
      <FDBox paddingY={1}>
        <FDBodyText value={group.attr('name')} />
      </FDBox>
      {serviceLineItems.map((item) => (
        <ServiceItem key={item.id} serviceItem={item} />
      ))}
      <div style={{ height: '1px', backgroundColor: '#E0DAD0', marginTop: 8 }} />
    </FDStack>
  );
};

ServiceGroup.defaultProps = {};

ServiceGroup.propTypes = {
  group: PropTypes.instanceOf(Resource).isRequired,
};

export { ServiceGroup };
